import { createSlice } from "@reduxjs/toolkit";

const eddSlice = createSlice({
  name: "edd",
  initialState: {
    eddRequestData: {
      count: 0,
      next: null,
      previous: null,
      results: [],
    },
    loadingEddRequest: false,
  },
  reducers: {
    setEddRequestData: (state, action) => {
      state.eddRequestData = action.payload;
    },
    setLoadingEddRequest: (state, action) => {
      state.loadingEddRequest = action.payload;
    },
  },
});

export const {
  setEddRequestData,
  setLoadingEddRequest,
} = eddSlice.actions;

export default eddSlice.reducer;
